import React from "react"
import propTypes from "prop-types"
import { connect } from "react-redux"
import { confirmAlert } from "react-confirm-alert"
import { withRouter } from "react-router-dom"
import Loader from "react-loader-spinner"
import { validateForm } from "../../../../../../services/validation"
import {
  saveSupportTeam,
  deleteSupportTeam
} from "../../../../../../services/plans"
import configs from "../../../../../../configs"

import Tooltip from "../../../../../../components/Tooltip"
import Form, {
  Group,
  Label,
  Input,
  TextArea,
  Checkbox,
  Select
} from "../../../../../../components/Form"
import AlertPopup from "../../../../../../components/AlertPopup"
import Repeater from "../../../../components/Repeater"
import Button from "../../../../../../components/Button"
import InfoCard, {
  InfoCardItem,
  InfoCardTitle,
  InfoCardDescription,
  InfoCardLabel
} from "../../../../components/InfoCard"

import StatusTag, { Tag } from "../../../../components/StatusTags"

class SupportTeam extends React.Component {
  constructor(props) {
    super(props)

    this.state = {
      supportTeam: [],
      form: {
        firstName: {
          label: "First Name",
          placeholder: "Support Members Name",
          name: "firstName",
          type: "text",
          value: "",
          required: true
        },
        familyName: {
          label: "Family Name",
          placeholder: "Support Members Family Name",
          name: "familyName",
          type: "text",
          value: "",
          required: true
        },
        relationship: {
          label: "Relationship",
          placeholder: "What Is Your Relationship",
          name: "relationship",
          value: "",
          options: [
            {
              value: "S",
              label: "Spouse"
            },
            {
              value: "P",
              label: "Parent"
            },
            {
              value: "C",
              label: "Child"
            },
            {
              value: "E",
              label: "Extended Family"
            },
            {
              value: "F",
              label: "Friend"
            }
          ],
          required: true
        },
        email: {
          label: "Email",
          placeholder: "Enter Their Email",
          name: "email",
          type: "email",
          value: "",
          required: true
        },
        phone: {
          label: "Phone",
          placeholder: "What Is Their Contact Number",
          name: "phone",
          type: "text",
          value: "",
          required: false
        },
        supportProvided: {
          label: "Support Provided",
          name: "supportProvided",
          type: "textarea",
          value: "",
          required: false
        },
        consentToContact: {
          label:
            "I have the permission from my support team member to share their contact details",
          name: "consentToContact",
          type: "checkbox",
          checked: false,
          value: "",
          required: true,
          class: ""
        }
      },
      loading: false,
      isSubmitted: false,
      formIsHidden: true,
      currentId: null,
      popupAlertIsHidden: true
    }
  }

  componentDidMount() {
    this.updateSupportTeam()
  }

  componentDidUpdate(prevProps) {
    const {
      store: { plan }
    } = this.props

    if (plan.answers.supportTeam) {
      if (
        JSON.stringify(prevProps.store.plan.answers.supportTeam) !==
        JSON.stringify(plan.answers.supportTeam)
      ) {
        this.updateSupportTeam()
      }
    }
  }

  updateSupportTeam = () => {
    const {
      store: { plan }
    } = this.props

    if (plan.answers.supportTeam) {
      const supportTeam = []

      plan.answers.supportTeam.map(item => {
        const newItem = {
          id: item.id,
          firstName: item.first_name,
          familyName: item.last_name,
          relationship: item.relationship.relationship,
          email: item.email || "",
          phone: item.phone,
          supportProvided: item.relationship.support_provided,
          status: item.relationship.status
        }

        supportTeam.push(newItem)

        return null
      })

      this.setState(
        {
          supportTeam
        },
        () => {
          this.openFormByUrlParameter()
        }
      )
    }
  }

  openFormByUrlParameter = () => {
    const {
      id,
      history,
      store: { plan }
    } = this.props

    if (id !== undefined && plan.answers.supportTeam) {
      plan.answers.supportTeam.map(item => {
        if (id === item.id) {
          this.onFormOpen(null, item.id)
          history.push("/pre-plan/support-team")
        }

        return null
      })
    }
  }

  scrollToInvalidElement = fields => {
    Object.keys(fields).map((resKey, index) => {
      if (fields[resKey].message && index === 0) {
        const item = this.form.elements[resKey]
        const parent = item.closest
          ? item.closest(".form_group")
          : item[0].closest(".form_group")
        const offSet = parent.getBoundingClientRect().top + window.pageYOffset
        const supportsNativeSmoothScroll =
          "scrollBehavior" in document.documentElement.style

        if (supportsNativeSmoothScroll) {
          window.scrollTo({
            top: offSet,
            behavior: "smooth"
          })
        } else {
          window.scrollTo(0, offSet)
        }
      }

      return null
    })
  }

  closeAlertPopup = () => {
    this.setState({ popupAlertIsHidden: true })
  }

  handleNext = () => {
    const { onNext } = this.props
    onNext()
  }

  removeItem = index => {
    const {
      onDeleteSupportTeam,
      store: { user, plan }
    } = this.props

    confirmAlert({
      title: "Are you sure?",
      buttons: [
        {
          label: "Yes",
          onClick: () => {
            onDeleteSupportTeam(user.token, index, plan.id)
          }
        },
        {
          label: "No"
        }
      ]
    })
  }

  changeItem = () => {
    const { form, currentId } = this.state
    const {
      scrollToNav,
      onSaveSupportTeam,
      store: { user, plan }
    } = this.props

    const res = validateForm(form)

    if (Object.keys(res).length === 0 && res.constructor === Object) {
      const member = {
        first_name: form.firstName.value,
        last_name: form.familyName.value,
        email: form.email.value,
        support_provided: form.supportProvided.value,
        relationship: form.relationship.value,
        phone: form.phone.value
      }

      if (!currentId) {
        member.consent_to_contact = form.consentToContact.checked
      }

      scrollToNav()

      onSaveSupportTeam(
        user.token,
        currentId !== null ? currentId : "",
        member,
        currentId ? "edit" : "add",
        plan.id
      ).then(
        () => {
          if (currentId) {
            this.setState({ formIsHidden: true })
          } else {
            this.setState({ popupAlertIsHidden: false, formIsHidden: true })
          }
        },
        message => {
          if (message) {
            const newForm = {}

            Object.keys(message).map(key => {
              if (key === "first_name") {
                newForm.firstName = {
                  ...form.firstName,
                  message: message.first_name[0]
                }
              } else if (key === "last_name") {
                newForm.familyName = {
                  ...form.familyName,
                  message: message.last_name[0]
                }
              } else if (key === "relationship") {
                newForm.relationship = {
                  ...form.relationship,
                  message: message.relationship[0]
                }
              } else if (key === "email") {
                newForm.email = {
                  ...form.email,
                  message: message.email[0]
                }
              }

              return null
            })

            this.scrollToInvalidElement(newForm)

            this.setState({
              isSubmitted: true,
              form: {
                ...form,
                ...newForm
              }
            })
          }
        }
      )
    } else {
      this.scrollToInvalidElement(res)

      this.setState({
        isSubmitted: true,
        form: {
          ...form,
          ...res
        }
      })
    }
  }

  onFormOpen = (e, index) => {
    if (e) e.preventDefault()

    const { form, supportTeam } = this.state
    const { scrollToNav } = this.props

    const fillForm = (id, res) => {
      const newForm = {}
      let value

      Object.keys(form).map(key => {
        const ValueTypeOf = typeof form[key].value === "string" ? "" : []

        if (id === null) {
          value = ValueTypeOf
        } else if (res) {
          value = res[key]
        } else {
          value = ValueTypeOf
        }

        newForm[key] = {
          ...form[key],
          value,
          message: ""
        }

        return null
      })

      scrollToNav()

      if (id) {
        newForm.consentToContact.required = false
      } else {
        newForm.consentToContact.required = true
      }

      this.setState({
        formIsHidden: false,
        currentId: id,
        form: newForm,
        loading: false
      })
    }

    if (index) {
      this.setState({ loading: true })

      supportTeam.map(supportTeamMember => {
        if (supportTeamMember.id === index) {
          fillForm(supportTeamMember.id, {
            id: supportTeamMember.id,
            firstName: supportTeamMember.firstName,
            familyName: supportTeamMember.familyName,
            relationship: supportTeamMember.relationship,
            email: supportTeamMember.email,
            phone: supportTeamMember.phone,
            supportProvided: supportTeamMember.supportProvided,
            consentToContact: ""
          })
        }

        return null
      })
    } else {
      fillForm(null)
    }
  }

  onFormClose = () => {
    const { scrollToNav } = this.props

    scrollToNav()

    this.setState({ formIsHidden: true })
  }

  onChange = (name, field, value) => {
    const { form } = this.state

    this.setState({
      form: {
        ...form,
        [name]: {
          ...form[name],
          message: "",
          [field]: value
        }
      }
    })
  }

  render() {
    const {
      form,
      formIsHidden,
      isSubmitted,
      supportTeam,
      currentId,
      loading,
      popupAlertIsHidden
    } = this.state
    const {
      store: { plan, user }
    } = this.props

    const userIsGuardian = user.list_role.includes(configs.roles.Guardian)

    return (
      <>
        <div className="pre-plan_header">
          <div className="pre-plan_title">Your Support Team</div>
          <div className="pre-plan_description">
            You can add people such as your partner, family members, friends,
            LAC and Planner to your support team. Your pre-plan can be shared so
            they can review it and make recommendations on how to improve it.
          </div>
        </div>

        {plan.loading || loading ? (
          <Loader
            type="TailSpin"
            color="#0c4632"
            height={80}
            width={80}
            className="loader"
          />
        ) : (
          <div className="row support-team">
            <div className="col-xl-8 offset-xl-2">
              <Form
                formRef={el => {
                  this.form = el
                }}
              >
                {formIsHidden ? (
                  <>
                    {supportTeam.map(userT => (
                      <InfoCard
                        key={userT.id}
                        hideDelete={userIsGuardian}
                        onDelete={() => {
                          this.removeItem(userT.id)
                        }}
                        className="info-card--yellow-light"
                      >
                        <div className="row">
                          <div className="col-md-4">
                            <InfoCardItem>
                              <InfoCardLabel>Name</InfoCardLabel>
                              <InfoCardTitle>
                                {userT.firstName} {userT.familyName}
                              </InfoCardTitle>
                            </InfoCardItem>

                            <InfoCardItem>
                              <InfoCardLabel>Relationship</InfoCardLabel>
                              <InfoCardTitle>
                                {configs.relationship_labes[userT.relationship]}
                              </InfoCardTitle>
                            </InfoCardItem>
                          </div>

                          <div className="col-md-8">
                            <InfoCardItem>
                              <InfoCardLabel>Support Provided</InfoCardLabel>
                              <InfoCardDescription>
                                {userT.supportProvided
                                  ? userT.supportProvided
                                  : ""}
                              </InfoCardDescription>
                            </InfoCardItem>
                          </div>
                        </div>

                        <div className="info-card_footer">
                          <div className="row">
                            <div className="col">
                              <Button
                                button={{ type: "button" }}
                                onClick={e => {
                                  this.onFormOpen(e, userT.id)
                                }}
                                className="btn--secondary-light btn--width-lg btn--height-md"
                              >
                                Edit Support Member
                              </Button>
                            </div>
                            {userT.status && (
                              <div className="col">
                                {userT.status !== "accepted" && (
                                  <StatusTag>
                                    <Tag className="status-tags_tag--orange">
                                      Pending acceptance
                                    </Tag>
                                  </StatusTag>
                                )}
                              </div>
                            )}
                          </div>
                        </div>
                      </InfoCard>
                    ))}

                    {!userIsGuardian && (
                      <Group>
                        <Repeater
                          text="Add Someone To Your Support Team"
                          onClick={this.onFormOpen}
                        />
                      </Group>
                    )}

                    <Group className="form_btn-group form_group--padding-top-lg text-center">
                      <Button
                        button={{ type: "button" }}
                        onClick={this.handleNext}
                        className="btn--secondary-light btn--width-md btn--height-sm btn--font-size-md"
                      >
                        Next
                      </Button>
                    </Group>
                  </>
                ) : (
                  <>
                    <div className="pre-plan_form_header">
                      <div className="pre-plan_form_title">
                        Add A Support Member
                      </div>
                    </div>
                    <Group>
                      <Input
                        onChange={this.onChange}
                        isSubmitted={isSubmitted}
                        field={form.firstName}
                      />
                    </Group>

                    <Group>
                      <Input
                        onChange={this.onChange}
                        isSubmitted={isSubmitted}
                        field={form.familyName}
                      />
                    </Group>

                    <Group>
                      <Select
                        onChange={this.onChange}
                        isSubmitted={isSubmitted}
                        field={form.relationship}
                      />
                    </Group>

                    <Group>
                      <Input
                        onChange={this.onChange}
                        isSubmitted={isSubmitted}
                        field={form.email}
                      />
                    </Group>

                    <Group>
                      <Input
                        onChange={this.onChange}
                        isSubmitted={isSubmitted}
                        field={form.phone}
                      />
                    </Group>

                    <Group className="form_group--with-tooltip">
                      <Tooltip>
                        Tell us about how they currently provide support to you.
                      </Tooltip>

                      <TextArea
                        onChange={this.onChange}
                        isSubmitted={isSubmitted}
                        field={form.supportProvided}
                      />
                    </Group>

                    {form.consentToContact.required && (
                      <Group>
                        <Label
                          label="Contact Details Consent"
                          htmlFor={form.consentToContact.name}
                        />

                        <Checkbox
                          onChange={this.onChange}
                          isSubmitted={isSubmitted}
                          field={form.consentToContact}
                        />
                      </Group>
                    )}

                    <Group className="form_btn-group form_group--padding-top-lg">
                      <Button
                        button={{ type: "button" }}
                        onClick={this.onFormClose}
                        className="btn--empty-secondary-light btn--width-md btn--height-sm btn--font-size-md"
                      >
                        Back
                      </Button>
                      <Button
                        button={{ type: "button", disabled: userIsGuardian }}
                        onClick={this.changeItem}
                        className="btn--secondary-light btn--width-md btn--height-sm btn--font-size-md"
                      >
                        {currentId === null
                          ? "Invite Support Member"
                          : "Save Changes"}
                      </Button>
                    </Group>
                  </>
                )}
              </Form>
            </div>
          </div>
        )}

        <AlertPopup
          title="Support team invitation sent"
          description="Your invitation has been sent to your support team member’s email inbox. Once they accept they can inspect and make suggestions to improve your pre-plan."
          isHidden={popupAlertIsHidden}
          onClose={this.closeAlertPopup}
          type="success"
        />
      </>
    )
  }
}

SupportTeam.propTypes = {
  history: propTypes.shape({
    push: propTypes.func
  }).isRequired,
  onNext: propTypes.func.isRequired,
  scrollToNav: propTypes.func.isRequired,
  onSaveSupportTeam: propTypes.func.isRequired,
  onDeleteSupportTeam: propTypes.func.isRequired,
  id: propTypes.oneOfType([propTypes.string, propTypes.number]).isRequired,
  store: propTypes.shape({
    user: propTypes.shape({
      name: propTypes.string,
      token: propTypes.string,
      list_role: propTypes.arrayOf(propTypes.number)
    }),
    plan: propTypes.shape({
      loading: propTypes.bool,
      id: propTypes.oneOfType([propTypes.string, propTypes.number]),
      answers: propTypes.shape({
        supportTeam: propTypes.arrayOf(
          propTypes.shape({
            id: propTypes.string,
            first_name: propTypes.string,
            last_name: propTypes.string,
            email: propTypes.string,
            phone: propTypes.string,
            relationship: propTypes.shape({
              relationship: propTypes.string,
              support_provided: propTypes.string
            })
          })
        )
      })
    })
  }).isRequired
}

const mapStateToProps = ({ AuthenticationReducer, PlansReducer }) => ({
  store: {
    user: AuthenticationReducer.user,
    plan: PlansReducer
  }
})

const mapDispatchToProps = dispatch => ({
  onSaveSupportTeam: (token, memberId, member, type, planId) =>
    dispatch(saveSupportTeam(token, memberId, member, type, planId)),
  onDeleteSupportTeam: (token, memberId, planId) =>
    dispatch(deleteSupportTeam(token, memberId, planId))
})

export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(SupportTeam)
)
